/* TT DRAWER - opens and closes the shared side panel / phone sheet (.tt-drw, styled in tt-filter.css).
   Used by In-Store Pickup (snippets/pickup-availability.liquid) and Back in Stock (back-in-stock.js).
   Also holds window.ttMember: the one Yotpo lookup and reward rules shared by the My Account drawer
   (tt-account.js) and the phone menu's account row (header-sidebar.liquid).
   Open: any button with data-tt-drw-open="<drawer id>". Close: the x, the dim, Escape, or swipe down on a
   phone (tt-sheet-swipe.js). While open the drawer lives on <body>, so nothing on the page can clip it or
   sit over it. The product form redraws its blocks on every size or colour pick and brings a fresh copy of
   the drawer with it; the copy that was moved to <body> is dropped the next time it opens. */
(function () {
  if (window.ttDrawer) return;

  var current = null;
  var lastFocus = null;

  function open(id) {
    // Newest copy first: the one still inside the page (the moved copy sits at the end of <body>).
    var copies = document.querySelectorAll('.tt-drw[id="' + id + '"]');
    if (!copies.length) return;
    var drawer = copies[0];
    for (var i = 1; i < copies.length; i++) copies[i].remove();
    if (current && current !== drawer) close();
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
    void drawer.offsetHeight; // start the slide from the closed position
    lastFocus = document.activeElement;
    current = drawer;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.documentElement.classList.add('tt-drw-open');
    document.documentElement.style.overflow = 'hidden';
    // Move keyboard focus into the drawer (the panel itself, so no focus ring appears on the x for mouse users).
    var panel = drawer.querySelector('.tt-drw__panel');
    if (panel) {
      panel.setAttribute('tabindex', '-1');
      panel.style.outline = 'none';
      setTimeout(function () { panel.focus({ preventScroll: true }); }, 340);
    }
  }

  function close() {
    if (!current) return;
    var drawer = current;
    current = null;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tt-drw-open');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-tt-drw-open]');
    if (opener) {
      event.preventDefault();
      open(opener.getAttribute('data-tt-drw-open'));
      return;
    }
    if (current && event.target.closest('[data-tt-drw-close]')) close();
    // In-Store Pickup's Add to Bag (Oct 24): close the drawer and press the product page's own Add to Bag, so the
    // size is added and the bag opens exactly as it does from the page. The drawer always shows the size picked there.
    var add = event.target.closest('[data-tt-pickup-add]');
    if (add) {
      event.preventDefault();
      var home = document.querySelector('pickup-availability');
      var section = home && home.closest('.shopify-section, [id^="shopify-section-"]');
      var buy = section && section.querySelector('form[action*="/cart/add"] [type="submit"]');
      close();
      if (buy) buy.click();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && current) close();
  });

  window.ttDrawer = { open: open, close: close };
})();

/* ---- Members: Yotpo lookup, reward rules, and the phone menu's account row ---- */
(function () {
  if (window.ttMember) return;
  var YOTPO_MERCHANT = '93341';
  // Points required -> dollars off, highest first. Must match the Rewards row and Yotpo's redemption options.
  var REWARD_STEPS = [[20000, 200], [10000, 100], [5000, 50], [3000, 30], [2500, 25], [2000, 20], [1500, 15], [1000, 10], [500, 5]];
  var FIRST_REWARD = 500;
  // Trina Turk Rewards is US only for now (Oct 22): the shopper's country is the flag in the header
  // (Shopify.country). Outside the US no tier, points or reward is shown and Yotpo is not asked.
  var REWARDS = !(window.Shopify && window.Shopify.country) || window.Shopify.country === 'US';

  function fmt(n) { return Number(n).toLocaleString('en-US'); }
  function dollars(points) {
    for (var i = 0; i < REWARD_STEPS.length; i++) if (points >= REWARD_STEPS[i][0]) return REWARD_STEPS[i][1];
    return 0;
  }
  // Tier (Oct 23): Yotpo's tier field, printed by Liquid (the menu row's data-tier, the account summary, the
  // Rewards row). Our Shopify "VIP" tags are no longer read: they come from our old Flow with the wrong rules.
  // A brand-new account is Bronze. (tags is kept in the signature so callers don't change.)
  function tierFrom(tags, isNew) {
    return isNew ? 'Bronze' : '';
  }
  // Live member details: the same two calls the Rewards row and Yotpo's own script make.
  function details() {
    var who = null;
    // no-store: the page may have asked this address while signed out; never reuse that empty answer.
    return fetch('/apps/loggedincustomer', { credentials: 'include', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.email || !c.id || !c.token) return null;
        who = c;
        return fetch('https://loyalty.yotpo.com/api/v1/customer_details'
          + '?customer_email=' + encodeURIComponent(c.email)
          + '&customer_external_id=' + encodeURIComponent(c.id)
          + '&customer_token=' + encodeURIComponent(c.token)
          + '&merchant_id=' + YOTPO_MERCHANT).then(function (r) { return r.ok ? r.json() : null; });
      })
      .then(function (d) {
        if (!who) return null;
        // Yotpo sometimes sends the balance as text ("125"); read it either way.
        var raw = d ? d.points_balance : null;
        var pts = raw === null || raw === undefined || raw === '' ? NaN : Number(raw);
        return {
          id: who.id,
          tags: who.tags || [],
          first: d && d.first_name ? String(d.first_name).trim() : (who.first_name ? String(who.first_name).trim() : ''),
          points: isFinite(pts) ? pts : null
        };
      })
      .catch(function (error) { console.warn('[members] details unavailable', error); return null; });
  }

  // Phone menu row: "Silver Member | 3,544 Points | $30 Reward". Tier alone until real points are in.
  function rowLine(row, tier, points) {
    var line = row.querySelector('[data-tt-menu-acct-line]');
    if (!line) return;
    var parts = [];
    if (!REWARDS) { tier = ''; points = null; }
    if (tier) parts.push(tier + ' Member');
    if (typeof points === 'number') {
      parts.push(fmt(points) + (points === 1 ? ' Point' : ' Points'));
      parts.push(dollars(points) > 0 ? '$' + dollars(points) + ' Reward' : fmt(FIRST_REWARD - points) + ' to Next Reward');
    }
    line.textContent = '';
    parts.forEach(function (text, i) {
      if (i) {
        var sep = document.createElement('span');
        sep.className = 'tt-drw__sep';
        sep.setAttribute('aria-hidden', 'true');
        sep.textContent = '|';
        line.appendChild(sep);
      }
      line.appendChild(document.createTextNode(text));
    });
    line.hidden = !parts.length;
  }

  function cached(id) {
    try { var v = sessionStorage.getItem('tt_rewards_' + id); return v === null || v === '' ? null : Number(v); } catch (e) { return null; }
  }

  // Signed in without a page load (the drawer): the header icon gets its dot and the menu row greets them.
  function signedIn(info) {
    document.querySelectorAll('.header__account-link > a').forEach(function (a) { a.setAttribute('href', '/account'); });
    // The header account panel was drawn for a signed-out shopper: the icon is a plain link to the account
    // page until the My Account drawer swaps in the signed-in panel (tt-account.js), or the next page.
    var apItem = document.querySelector('.header__account-link');
    if (apItem) apItem.setAttribute('data-tt-ap-off', '');
    var row = document.querySelector('[data-tt-menu-acct]');
    if (!row) return;
    row.setAttribute('href', '/account');
    // With the My Account drawer on the page, the row now opens their account in it (as on signed-in pages).
    if (document.getElementById('tt-account-drawer')) row.setAttribute('data-tt-account', 'account');
    else row.removeAttribute('data-tt-account');
    row.setAttribute('data-tt-menu-acct', 'in');
    var dot = row.querySelector('.tt-menu-acct__dot');
    if (dot) dot.hidden = false;
    var h = row.querySelector('.tt-menu-acct__h');
    if (h) h.textContent = info && info.first ? 'Welcome Back, ' + info.first : 'Welcome Back';
    rowLine(row, info && info.tier, info && info.points);
  }

  // Signed-in pages: the row shows the tier from Shopify straight away; the points are asked for the first
  // time the menu opens (not on page load), from this visit's last known balance first, then Yotpo.
  var asked = false;
  function fillMenu() {
    var row = document.querySelector('[data-tt-menu-acct="in"]');
    if (!row || asked || !REWARDS) return;
    asked = true;
    var tier = row.getAttribute('data-tier') || '';
    var id = row.getAttribute('data-customer') || '';
    var known = id ? cached(id) : null;
    if (typeof known === 'number' && isFinite(known)) rowLine(row, tier, known);
    details().then(function (m) {
      if (m && typeof m.points === 'number') {
        rowLine(row, tier || tierFrom(m.tags, false), m.points);
        try { sessionStorage.setItem('tt_rewards_' + m.id, String(m.points)); } catch (e) {}
      }
    });
  }
  document.addEventListener('dialog:before-show', function (event) {
    if (event.target && event.target.id === 'sidebar-menu') fillMenu();
  }, true);

  // The next reward above a balance: [points needed, dollars], or null at the top level.
  function nextReward(points) {
    var next = null;
    for (var i = 0; i < REWARD_STEPS.length; i++) if (points < REWARD_STEPS[i][0]) next = REWARD_STEPS[i];
    return next;
  }

  // Account summary (snippets/tt-account-summary.liquid), in the header panel or the My Account drawer.
  // Oct 24 instrument-panel layout: the reward they can use now ($30, hidden under 500 points) and the points,
  // side by side; one bar to the next reward with "1,456 points to a $50 Reward"; no bar at the top level.
  function paintSummary(root, points) {
    var box = root.querySelector('[data-tt-ap-points]');
    if (!box) return;
    function q(sel) { return root.querySelector(sel); }
    var now = dollars(points);
    var next = nextReward(points);
    q('[data-tt-ap-balance]').textContent = fmt(points);
    var label = q('[data-tt-ap-balance-l]');
    if (label) label.textContent = points === 1 ? 'Point' : 'Points';
    var rewardBox = q('[data-tt-ap-reward-g]');
    q('[data-tt-ap-reward]').textContent = now > 0 ? '$' + now : '';
    if (rewardBox) rewardBox.hidden = !(now > 0);
    if (next) {
      q('[data-tt-ap-bar]').style.width = Math.max(2, Math.min(100, Math.round(points / next[0] * 100))) + '%';
      var gap = next[0] - points;
      q('[data-tt-ap-togo]').textContent = fmt(gap) + (gap === 1 ? ' point' : ' points') + ' to a $' + next[1] + ' Reward';
    }
    q('[data-tt-ap-next]').hidden = !next;
    box.hidden = false;
  }

  // Fills a summary: a balance already in hand is painted straight away (and again whenever one is handed
  // in); otherwise, once, this visit's last known balance first, then Yotpo's.
  function summary(root, points) {
    var box = root && root.querySelector('[data-tt-ap-points]');
    if (!box || !REWARDS) return;
    if (typeof points === 'number' && isFinite(points)) { box.setAttribute('data-tt-asked', ''); paintSummary(root, points); return; }
    if (box.hasAttribute('data-tt-asked')) return;
    box.setAttribute('data-tt-asked', '');
    var known = cached(box.getAttribute('data-customer'));
    if (typeof known === 'number' && isFinite(known)) paintSummary(root, known);
    details().then(function (d) {
      if (!d || typeof d.points !== 'number') return;
      paintSummary(root, d.points);
      try { sessionStorage.setItem('tt_rewards_' + d.id, String(d.points)); } catch (e) {}
    });
  }

  window.ttMember = { rewards: REWARDS, FIRST_REWARD: FIRST_REWARD, fmt: fmt, dollars: dollars, nextReward: nextReward, cached: cached, tierFrom: tierFrom, details: details, signedIn: signedIn, summary: summary };
})();

/* ---- Account panel under the header account icon (snippets/tt-account-panel.liquid; styles: .tt-ap) ----
   Mouse: opens after a short pause on hover (passing over the icon doesn't flash it), closes a moment after
   the pointer leaves; clicking the icon still goes to the account page. Touch: the first tap on the icon opens
   it, a tap anywhere else closes it. Keyboard: opens when the icon gets focus, Escape closes. Signed in, the
   points and next reward are asked for the first time it opens (this visit's last known balance first). */
(function () {
  var item = document.querySelector('.header__account-link');
  var panel = item && item.querySelector('[data-tt-ap]');
  if (!panel || window.ttAccountPanel) return;
  var link = item.querySelector('a');
  var wide = window.matchMedia('(min-width: 700px)');
  var hover = window.matchMedia('(hover: hover)');
  var openTimer = null;
  var closeTimer = null;
  var lastPointer = 'mouse';

  function off() { return item.hasAttribute('data-tt-ap-off') || !wide.matches; }

  // Signed in: the points in the summary, asked the first time the panel opens (ttMember.summary).
  function fill() {
    if (window.ttMember) window.ttMember.summary(panel);
  }

  // Drop the panel just below the header, whatever its height at this width.
  function place() {
    var header = item.closest('.header') || item.closest('header');
    if (!header) return;
    var gap = header.getBoundingClientRect().bottom - item.getBoundingClientRect().bottom;
    panel.style.setProperty('--tt-ap-gap', Math.max(8, Math.round(gap)) + 'px');
  }

  function show() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (!panel.hidden || off()) return;
    place();
    panel.hidden = false;
    link.setAttribute('aria-expanded', 'true');
    fill();
  }

  function hide() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    if (panel.hidden) return;
    panel.hidden = true;
    link.setAttribute('aria-expanded', 'false');
  }

  link.setAttribute('aria-expanded', 'false');
  link.setAttribute('aria-haspopup', 'true');

  item.addEventListener('pointerenter', function (event) {
    if (event.pointerType !== 'mouse') return;
    clearTimeout(closeTimer);
    if (panel.hidden) openTimer = setTimeout(show, 150);
  });
  item.addEventListener('pointerleave', function (event) {
    if (event.pointerType !== 'mouse') return;
    clearTimeout(openTimer);
    closeTimer = setTimeout(hide, 300);
  });

  document.addEventListener('pointerdown', function (event) {
    lastPointer = event.pointerType || 'mouse';
    if (!panel.hidden && !item.contains(event.target)) hide();
  }, true);

  // Touch: the first tap opens the panel instead of following the link.
  link.addEventListener('click', function (event) {
    if (off() || (hover.matches && lastPointer === 'mouse')) return;
    if (panel.hidden) { event.preventDefault(); show(); }
  });

  // Keyboard: open when the icon gets keyboard focus; close once focus leaves the icon and panel.
  var refocus = false;
  link.addEventListener('focus', function () { if (!refocus && link.matches(':focus-visible')) show(); });
  item.addEventListener('focusout', function (event) {
    if (!item.contains(event.relatedTarget)) closeTimer = setTimeout(hide, 150);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || panel.hidden) return;
    hide();
    refocus = true;
    link.focus({ preventScroll: true });
    refocus = false;
  });

  // Sign In / Create Account open the My Account drawer (tt-account.js); the panel steps aside.
  panel.addEventListener('click', function (event) {
    if (event.target.closest('[data-tt-account]')) hide();
  });

  window.ttAccountPanel = { show: show, hide: hide };
})();
